import PropTypes from 'prop-types'

import { ReactComponent as GolferIcon } from '../../../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as CheckCircle } from '../../../../../assets/images/common/icons/check-circle.svg'
import { ReactComponent as CancelCircle } from '../../../../../assets/images/common/icons/cancel-circle.svg'
import StockProfilePic from '../../../../../assets/images/mock/default-profile-icon.png'
import SubmitButton from '../../../../common/buttons/SubmitButton'

import styles from './SessionCard.module.scss'

const EventCard = ({ event, handleRSVP }) => (
  <div className={styles.sessionCard}>
    <div className={styles.header}>
      <p className={styles.title}>{`${event.seriesName} - ${event.name}`}</p>
    </div>
    <p className={styles.subtitle}>{event.format}</p>

    <div>
      <i className={`fa fa-clock-o ${styles.faIcon}`}/>
      <span className={styles.text}>
        {event.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).toLowerCase()}
      </span>
    </div>

    {
      event.location &&
      <div>
        <i className={`fa fa-map-marker ${styles.faIcon}`}/><span className={styles.text}>{event.location}</span>
      </div>
    }

    <div className={styles.enrollments}>
      <GolferIcon className={styles.icon}/>
      <span className={styles.textStudents}>{event.students.length} Students</span>
    </div>

    <div className={styles.studentsProfiles}>
      {event.students.slice(0, 4).map((student) =>
        <div
          className={styles.profileImg}
          key={student.id}
          style={{
            backgroundImage: student.avatarUrl
              ? `url(${student.avatarUrl})`
              : `url(${StockProfilePic})`,
          }}
        />
      )}
      {event.students.length > 4 && <div className={styles.moreProfiles}>+ {event.students.length - 4} more</div>}
    </div>
    {
      event.students[0].enrollment.status === 'created' ?
        <SubmitButton
          onClick={(e) => { e.preventDefault(); handleRSVP() }}
          buttonMessage={event.rsvpStatus === 'open' ? 'Click here to RSVP' : 'RSVP Closed'}
          buttonColor='orange-button'
          disabled={event.rsvpStatus !== 'open'}
        />
        :
        <div className={styles.rsvpStatus}>
          {event.students[0].enrollment.status === 'confirmed'
            ?
            <div className={styles.attending}>
              <CheckCircle className='mr-2'/> Attending
            </div>
            :
            <div className={styles.notAttending}>
              <CancelCircle className='mr-2'/> Not Attending
            </div>
          }
        </div>
    }
  </div>
)

EventCard.propTypes = {
  event: PropTypes.shape({
    date: PropTypes.object,
    location: PropTypes.string,
    id: PropTypes.number,
    seriesName: PropTypes.string,
    name: PropTypes.string,
    format: PropTypes.string,
    students: PropTypes.array,
    rsvpStatus: PropTypes.string,
  }),
  handleRSVP: PropTypes.func.isRequired,
}

export default EventCard
